module.exports = __webpack_public_path__ + "static/media/home-24-logo.9e428a35.gif";